import {v4 as guid} from 'uuid';
import * as requestFromServer from './projectsCrud';
import {callTypes, projectsSlice} from './projectsSlice';
import {showProgressBarPopUp} from '../../_common/actions/progressBarPopUp/showProgressBarPopUp';
import {hideProgressBarPopUp} from '../../_common/actions/progressBarPopUp/hideProgressBarPopUp';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {RequestCancellationManager} from "../../_common/utils/RequestCancellationManager";
import * as actionsGlobal from "../../_common/actions/globalMessage/showGlobalMessage";
import {customersForProjectsSlice} from "./customersForProjectsSlice";
import {markedIgnoredCustomersSlice} from "./markedIgnoredCustomersSlice";

export const getProjectsListIDPrefix = 'getProjectsList';
const {actions} = projectsSlice;

export const getCustomersForProjectsIDPrefix = 'getCustomersForProjects';
const actionsCustomers = customersForProjectsSlice.actions;
const actionsImportedCustomers = markedIgnoredCustomersSlice.actions;

const getProjectsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getProjectsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getProjectsList(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalCount, list, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: list
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find projects';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const createProject = name => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .createProject({name})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
      if (errorCode === 0) {
        dispatch(actions.addProject({data}));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't create project!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const editProject = (id, name) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .editProject(id, name)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
      if (errorCode === 0) {
        dispatch(actions.editProject({id, name}));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't create project!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const deleteProject = id => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .deleteProject({id})
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
      if (errorCode === 0) {
        dispatch(actions.deleteProject({id}))
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't delete project!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

const getCustomersForProjects = storeMethod => text => queryParams => dispatch => {
  dispatch(actionsCustomers.startCall({callType: callTypes.list}));

  const requestID = `${getCustomersForProjectsIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);
  const params = {...queryParams, text};

  return requestFromServer
    .getCustomersForProjects(params, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalCustomers, list, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount: totalCustomers,
        pageCount,
        entities: list
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find customers';
      dispatch(actionsCustomers.catchError({error, callType: callTypes.list}));
    });
};

export const addCustomerToProject = (projectId, customerId, name, email) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .addCustomerToProject(projectId, customerId)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
      if (errorCode === 0) {
        dispatch(actions.addCustomerToProject({projectId, customerId, name, email}));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't add customer to project!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const removeCustomerFromProject = (projectId, customerId) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .removeCustomerFromProject(projectId, customerId)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
      if (errorCode === 0) {
        dispatch(actions.removeCustomerFromProject({projectId, customerId}));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't remove customer from project!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const exportProjectsFile = projectID => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getProjectsFile({projectID})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }

      return data.list;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't get file!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const uploadCustomersForProject = (projectId, file) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  dispatch(showProgressBarPopUp(M.UPLOADING_FILE));
  const formData = new FormData();
  formData.set('content', file);
  formData.set('projectId', projectId);

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  return requestFromServer
    .uploadFile({formData})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode === 0) {
        const markedCustomers = data.marked || [];
        dispatch(actionsImportedCustomers.customersFetched(data));
        dispatch(actions.changeCustomersCount({projectId, markedCustomers}));
        return errorCode
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
        throw new Error();
      }
    })
    .then(() => delay(2500))
    .then(() => dispatch(hideProgressBarPopUp()))
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't upload file!";
      dispatch(hideProgressBarPopUp());
      dispatch(actions.catchError({error, callType: callTypes.action}));
    })
    .finally(() => dispatch(hideProgressBarPopUp()))
};

export const getProjects = getProjectsList(actions.projectsFetched);
export const getNextProjects = getProjectsList(actions.projectsAppended);

export const getCustomers = getCustomersForProjects(actionsCustomers.customersForProjectsFetched);
export const getNextCustomers = getCustomersForProjects(actionsCustomers.customersForProjectsAppended);